module.exports = __webpack_public_path__ + "cd3935bf04218f714a74782cc675f13c.png";